// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'
import {
  ASSIGN_CASE_SUMMARY_CASE_DETAILS_TERR_CASE_ID,
  ASSIGN_CASE_SUMMARY_CASE_OH_DETAILS_TERR_CASE_ID,
  ASSIGN_CASE_SUMMARY_CHANNEL_CASE_LIST,
  ASSIGN_CASE_SUMMARY_OPEN_SUMMARY,
  ASSIGN_CASE_SUMMARY_SELECTED_TERR_CASE_IDS,
  CASE_SUMMARY_SHOW_ALL_CASES_TOGGLE,
  UPDATE_INTERFERENCE_ANALYSIS_STATE,
} from './types'

import initialState from './initialState'

const interferenceAnalysis = (state = initialState, action) => {
  switch (action.type) {
    case ASSIGN_CASE_SUMMARY_CASE_DETAILS_TERR_CASE_ID :
      return (
        state
          .setIn(['caseSummary', 'caseDetailsTerrCaseId'], action.caseDetailsTerrCaseId)
          .setIn(['caseSummary', 'caseOhDetailsTerrCaseId'], null)
      )

    case ASSIGN_CASE_SUMMARY_CASE_OH_DETAILS_TERR_CASE_ID :
      return (
        state
          .setIn(['caseSummary', 'caseOhDetailsTerrCaseId'], action.caseOhDetailsTerrCaseId)
          .setIn(['caseSummary', 'caseDetailsTerrCaseId'], null)
      )

    case ASSIGN_CASE_SUMMARY_CHANNEL_CASE_LIST :
      return state.merge(
        fromJS({
          caseSummary: {
            ...state.get('caseSummary').toJS(),
            channelCaseList: action.channelCaseList,
          },
        })
      )

    case ASSIGN_CASE_SUMMARY_OPEN_SUMMARY :
      return state.merge(
        fromJS({
          caseSummary: {
            ...state.get('caseSummary').toJS(),
            caseDetailsTerrCaseId: null,
            caseOhDetailsTerrCaseId: null,
            channelCaseList: [],
            openSummaryUID: action.openSummaryUID,
            selectedTerrCaseIds: [],
          },
        })
      )

    case ASSIGN_CASE_SUMMARY_SELECTED_TERR_CASE_IDS :
      return state.setIn(
        ['caseSummary', 'selectedTerrCaseIds'],
        action.selectedTerrCaseIds
      )

    case CASE_SUMMARY_SHOW_ALL_CASES_TOGGLE :
      return state.setIn(
        ['caseSummary', 'showAllCases'],
        !state.getIn(['caseSummary', 'showAllCases'])
      )

    case UPDATE_INTERFERENCE_ANALYSIS_STATE :
      return state.merge(
        fromJS({ ...action.newState })
      )

    default :
      return state
  }
}

export default interferenceAnalysis
